import { Typography } from '@material-ui/core';
import React, { useContext } from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { Tcard } from './mainTcard';
import { TCaredDashboardContext } from '../tCaredDashboard-Provider';

const marginBottom = { marginBottom: 8 };

const TcardMapList = ({
    List = [],
    tCardList,
    toBeScheduledCards,
    classes,
    portalSetting,
    expand,
    handleExpand,
    handleTcardOpen,
    legendItems,
    // Tcard,
    checkIsTcardReadonly
}) => {
    const { shortListByTrailter } = useContext(TCaredDashboardContext);

    return (
        <React.Fragment>
            {List.map((col, index) => {
                let dataList = toBeScheduledCards(tCardList?.tCardStatus);
                let filterList = tCardList?.tCardStatus.filter((m) => m.status === col.status) || [];
                if (col.status === 'TO BE SCHEDULED') {
                    filterList = tCardList?.toSchedule || [];
                    return (
                        <React.Fragment key={index}>
                            <div style={{ background: 'lightgrey' }}>
                                <Typography
                                    style={{
                                        textAlign: 'center',
                                        fontWeight: 700,
                                        textTransform: 'uppercase',
                                        fontSize: 12
                                    }}
                                >
                                    {col.status} <small>{tCardList?.tCardStatus?.filter((m) => m.status === col.status).length}</small>
                                </Typography>
                            </div>

                            <div className={`${classes.colHeight} custom-scroll`}>
                                {dataList
                                    .sort(([weekA], [weekB]) => {
                                        const numA = parseInt(weekA.replace(/\D/g, ''), 10);
                                        const numB = parseInt(weekB.replace(/\D/g, ''), 10);
                                        return numA - numB;
                                    })
                                    .map(([week, cards]) => (
                                        <Droppable key={`${col.status}-${week}`} droppableId={`${col.status}-${week}`} direction="vertical">
                                            {(provided, snapshot) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.droppableProps}
                                                    style={{
                                                        background: portalSetting.portalSettingsIsHolidayColor
                                                        // marginBottom: 8
                                                    }}
                                                >
                                                    <Typography
                                                        style={{
                                                            fontWeight: 600,
                                                            fontSize: 12,
                                                            background: portalSetting.portalSettingsIsHolidayBgColor || '#F88379',
                                                            color: portalSetting.portalSettingsIsHolidayColor,
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                            padding: '0 5px'
                                                        }}
                                                    >
                                                        <span>
                                                            {week} - {cards.length}
                                                        </span>
                                                        <span>
                                                            {!expand[week] ? (
                                                                <ExpandMoreIcon
                                                                    onClick={() => handleExpand(week, true)}
                                                                    style={{
                                                                        fontSize: 12,
                                                                        marginRight: 5,
                                                                        marginTop: 1,
                                                                        cursor: 'pointer'
                                                                    }}
                                                                />
                                                            ) : (
                                                                <ExpandLessIcon
                                                                    onClick={() => handleExpand(week, false)}
                                                                    style={{
                                                                        fontSize: 12,
                                                                        marginRight: 5,
                                                                        marginTop: 1,
                                                                        cursor: 'pointer'
                                                                    }}
                                                                />
                                                            )}
                                                        </span>
                                                    </Typography>

                                                    {expand[week] &&
                                                        shortListByTrailter(cards).map((k, index) => (
                                                            <Draggable
                                                                key={k.tCardsID}
                                                                isDragDisabled={checkIsTcardReadonly}
                                                                draggableId={k.tCardsID.toString()}
                                                                index={index}
                                                            >
                                                                {(provided) => (
                                                                    <div
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}
                                                                        style={{
                                                                            // marginBottom: 8,
                                                                            ...provided.draggableProps.style
                                                                        }}
                                                                    >
                                                                        <Tcard
                                                                            legendItems={legendItems}
                                                                            handleTcardOpen={handleTcardOpen}
                                                                            days={k.days}
                                                                            date={k.dd}
                                                                            customer={k.cust}
                                                                            isLoanVehicle={k.loanVehicle}
                                                                            registration={k.reg}
                                                                            textColor={k.tc}
                                                                            color={k.bgc}
                                                                            wn={k.wn}
                                                                            tCardsID={k.tCardsID}
                                                                            vsc={k.vsc}
                                                                            breakdown={k.breakdown}
                                                                            breakdownStatus={k.breakdownStatus}
                                                                            breakdownTime={k.breakdownTime}
                                                                            status={{
                                                                                recall: k.recall,
                                                                                tacho: k.tacho,
                                                                                mot: k.mot,
                                                                                repair: k.repair,
                                                                                inspection: k.inspection,
                                                                                cd: k.cd,
                                                                                waiting: k.waiting,
                                                                                service: k.service,
                                                                                ns: k.ns
                                                                            }}
                                                                        />
                                                                    </div>
                                                                )}
                                                            </Draggable>
                                                        ))}

                                                    {provided.placeholder}
                                                </div>
                                            )}
                                        </Droppable>
                                    ))}
                            </div>

                            {/* Date Not Set Section */}
                            <Droppable droppableId={`${col.status}`} direction="vertical">
                                {(provided, snapshot) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.droppableProps}
                                        className={`${classes.colHeight} custom-scroll`}
                                        style={marginBottom}
                                    >
                                        <div style={{ background: portalSetting.portalSettingsIsHolidayColor }}>
                                            <Typography
                                                style={{
                                                    fontWeight: 600,
                                                    fontSize: 12,
                                                    background: portalSetting.portalSettingsIsHolidayBgColor || '#F88379',
                                                    color: portalSetting.portalSettingsIsHolidayColor,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    padding: '0 5px'
                                                }}
                                            >
                                                <span>Date not set</span>
                                                <span>
                                                    {!expand['notSet'] ? (
                                                        <ExpandMoreIcon
                                                            onClick={() => handleExpand('notSet', true)}
                                                            style={{
                                                                fontSize: 12,
                                                                marginRight: 5,
                                                                marginTop: 1,
                                                                cursor: 'pointer'
                                                            }}
                                                        />
                                                    ) : (
                                                        <ExpandLessIcon
                                                            onClick={() => handleExpand('notSet', false)}
                                                            style={{
                                                                fontSize: 12,
                                                                marginRight: 5,
                                                                marginTop: 1,
                                                                cursor: 'pointer'
                                                            }}
                                                        />
                                                    )}
                                                </span>
                                            </Typography>

                                            {expand['notSet'] &&
                                                shortListByTrailter(tCardList?.tCardStatus?.filter((m) => m.status === col.status && !m.dd)).map((k, index) => (
                                                    <Draggable
                                                        key={k.tCardsID}
                                                        isDragDisabled={checkIsTcardReadonly}
                                                        draggableId={k.tCardsID.toString()}
                                                        index={index}
                                                    >
                                                        {(provided) => (
                                                            <div
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                style={{
                                                                    marginBottom: 8,
                                                                    ...provided.draggableProps.style
                                                                }}
                                                            >
                                                                <Tcard
                                                                    legendItems={legendItems}
                                                                    handleTcardOpen={handleTcardOpen}
                                                                    days={k.days}
                                                                    date={k.dd}
                                                                    customer={k.cust}
                                                                    isLoanVehicle={k.loanVehicle}
                                                                    registration={k.reg}
                                                                    textColor={k.tc}
                                                                    color={k.bgc}
                                                                    wn={k.wn}
                                                                    tCardsID={k.tCardsID}
                                                                    vsc={k.vsc}
                                                                    breakdown={k.breakdown}
                                                                    breakdownStatus={k.breakdownStatus}
                                                                    breakdownTime={k.breakdownTime}
                                                                    status={{
                                                                        recall: k.recall,
                                                                        tacho: k.tacho,
                                                                        mot: k.mot,
                                                                        repair: k.repair,
                                                                        inspection: k.inspection,
                                                                        cd: k.cd,
                                                                        waiting: k.waiting,
                                                                        service: k.service,
                                                                        ns: k.ns
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                    </Draggable>
                                                ))}
                                        </div>
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </React.Fragment>
                    );
                }
                if (col.status === 'RECALL') {
                    return (
                        <React.Fragment key={index}>
                            <div style={{ background: 'lightgrey' }}>
                                <Typography
                                    style={{
                                        textAlign: 'center',
                                        fontWeight: 700,
                                        textTransform: 'uppercase',
                                        fontSize: 12
                                    }}
                                >
                                    Recall <small>({tCardList.recall.length})</small>
                                </Typography>
                            </div>
                            <div className={`${classes.colHeight} custom-scroll`} style={marginBottom}>
                                {tCardList.tpNames.map((tpName, tpIndex) => (
                                    <div key={tpName}>
                                        <Typography
                                            style={{
                                                paddingLeft: 5,
                                                textAlign: 'center',
                                                fontWeight: 700,
                                                textTransform: 'uppercase',
                                                fontSize: 10,
                                                backgroundColor: 'skyblue'
                                            }}
                                        >
                                            {tpName}
                                            {tpName == 'Next Inspection' && (
                                                <span>
                                                    {!expand[tpName] ? (
                                                        <ExpandMoreIcon
                                                            onClick={() => handleExpand(tpName, true)}
                                                            style={{
                                                                fontSize: 12,
                                                                marginRight: 5,
                                                                marginTop: 1,
                                                                cursor: 'pointer'
                                                            }}
                                                        />
                                                    ) : (
                                                        <ExpandLessIcon
                                                            onClick={() => handleExpand(tpName, false)}
                                                            style={{
                                                                fontSize: 12,
                                                                marginRight: 5,
                                                                marginTop: 1,
                                                                cursor: 'pointer'
                                                            }}
                                                        />
                                                    )}
                                                </span>
                                            )}
                                        </Typography>

                                        <Droppable droppableId={col.status} direction="vertical">
                                            {(provided, snapshot) => {
                                                const items = tCardList.recall.filter((m) => m.tp === tpName);

                                                return (
                                                    <div ref={provided.innerRef} {...provided.droppableProps}>
                                                        {items.length === 0 && !snapshot.isDraggingOver && (
                                                            <div className={classes.noRecordFound}>No Record Found</div>
                                                        )}

                                                        <div></div>

                                                        {items.map((k, index) => (
                                                            <Draggable
                                                                key={k.tCardsID}
                                                                isDragDisabled={checkIsTcardReadonly}
                                                                draggableId={k.tCardsID.toString()}
                                                                index={index}
                                                            >
                                                                {(provided) => (
                                                                    <div
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}
                                                                        style={{
                                                                            // marginBottom: 8,
                                                                            ...provided.draggableProps.style
                                                                        }}
                                                                    >
                                                                        {tpName == 'Next Inspection' ? (
                                                                            expand[k.tp] && (
                                                                                <Tcard
                                                                                    legendItems={legendItems}
                                                                                    handleTcardOpen={handleTcardOpen}
                                                                                    days={k.days}
                                                                                    date={k.bd}
                                                                                    customer={k.cust}
                                                                                    isLoanVehicle={k.loanVehicle}
                                                                                    registration={k.reg}
                                                                                    bg={k.bg}
                                                                                    wn={k.wn}
                                                                                    color={k.bgc}
                                                                                    tCardsID={k.tCardsID}
                                                                                    vsc={k.vsc}
                                                                                    breakdown={k.breakdown}
                                                                                    breakdownStatus={k.breakdownStatus}
                                                                                    breakdownTime={k.breakdownTime}
                                                                                    status={{
                                                                                        recall: k.recall,
                                                                                        tacho: k.tacho,
                                                                                        mot: k.mot,
                                                                                        repair: k.repair,
                                                                                        inspection: k.inspection,
                                                                                        cd: k.cd,
                                                                                        waiting: k.waiting,
                                                                                        service: k.service,
                                                                                        ns: k.ns
                                                                                    }}
                                                                                />
                                                                            )
                                                                        ) : (
                                                                            <Tcard
                                                                                legendItems={legendItems}
                                                                                handleTcardOpen={handleTcardOpen}
                                                                                date={k.bd}
                                                                                days={k.days}
                                                                                customer={k.cust}
                                                                                isLoanVehicle={k.loanVehicle}
                                                                                registration={k.reg}
                                                                                bg={k.bg}
                                                                                wn={k.wn}
                                                                                color={k.bgc}
                                                                                tCardsID={k.tCardsID}
                                                                                vsc={k.vsc}
                                                                                breakdown={k.breakdown}
                                                                                breakdownStatus={k.breakdownStatus}
                                                                                breakdownTime={k.breakdownTime}
                                                                                status={{
                                                                                    recall: k.recall,
                                                                                    tacho: k.tacho,
                                                                                    mot: k.mot,
                                                                                    repair: k.repair,
                                                                                    inspection: k.inspection,
                                                                                    cd: k.cd,
                                                                                    waiting: k.waiting,
                                                                                    service: k.service,
                                                                                    ns: k.ns
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </Draggable>
                                                        ))}

                                                        {items.length - 1 === index && snapshot.isDraggingOver && items.length > 0 && (
                                                            <div className={classes.noRecordFound}>Drop Here</div>
                                                        )}
                                                        {provided.placeholder}
                                                    </div>
                                                );
                                            }}
                                        </Droppable>
                                    </div>
                                ))}
                            </div>
                        </React.Fragment>
                    );
                } else {
                    return (
                        <React.Fragment key={index}>
                            <div style={{ background: 'lightgrey' }}>
                                <Typography
                                    style={{
                                        textAlign: 'center',
                                        fontWeight: 700,
                                        textTransform: 'uppercase',
                                        fontSize: 12
                                    }}
                                >
                                    {col.status} <small>({filterList?.length})</small>
                                </Typography>
                            </div>

                            <Droppable droppableId={col.status} direction="vertical">
                                {(provided, snapshot) => {
                                    const filteredCards = tCardList?.tCardStatus?.filter((m) => m.status === col.status) || [];

                                    let sortList = shortListByTrailter(filteredCards);

                                    return (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                            className={`${classes.colHeight} custom-scroll`}
                                            style={marginBottom}
                                        >
                                            {sortList.length === 0 && (
                                                <div className={'card-body-container-main-wrapper-no-record'}>
                                                    <span>{snapshot.isDraggingOver ? 'Drop Here' : 'No Record Found'}</span>
                                                </div>
                                            )}

                                            {sortList.map((k, index) => (
                                                <Draggable
                                                    key={k.tCardsID}
                                                    isDragDisabled={checkIsTcardReadonly}
                                                    draggableId={k.tCardsID.toString()}
                                                    index={index}
                                                >
                                                    {(provided) => (
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            style={{
                                                                // marginBottom: 8,
                                                                ...provided.draggableProps.style
                                                            }}
                                                        >
                                                            <Tcard
                                                                legendItems={legendItems}
                                                                handleTcardOpen={handleTcardOpen}
                                                                days={k.days}
                                                                date={k.bd}
                                                                customer={k.cust}
                                                                isLoanVehicle={k.loanVehicle}
                                                                registration={k.reg}
                                                                textColor={k.tc}
                                                                color={k.bgc}
                                                                tCardsID={k.tCardsID}
                                                                wn={k.wn}
                                                                vsc={k.vsc}
                                                                breakdown={k.breakdown}
                                                                breakdownStatus={k.breakdownStatus}
                                                                breakdownTime={k.breakdownTime}
                                                                status={{
                                                                    recall: k.recall,
                                                                    tacho: k.tacho,
                                                                    mot: k.mot,
                                                                    repair: k.repair,
                                                                    inspection: k.inspection,
                                                                    cd: k.cd,
                                                                    waiting: k.waiting,
                                                                    service: k.service,
                                                                    ns: k.ns
                                                                }}
                                                            />
                                                            {snapshot.isDraggingOver && filteredCards.length > 0 && (
                                                                <div className={'card-body-container-main-wrapper-no-record'}>
                                                                    <span>Drop Here</span>
                                                                </div>
                                                            )}
                                                            {provided.placeholder}
                                                        </div>
                                                    )}
                                                </Draggable>
                                            ))}
                                        </div>
                                    );
                                }}
                            </Droppable>
                        </React.Fragment>
                    );
                }
            })}
        </React.Fragment>
    );
};

export default TcardMapList;
